<script>
import { searchState } from "../Store/SearchStateStore"
import { fade, fly } from 'svelte/transition'
import { onDestroy, onMount } from "svelte"
import { overlay } from "../Store/OverlayStore"
import Spinner from "./Spinner.svelte"
import LocationList from "./LocationList.svelte"
import Search from "./Search.svelte"
import { allLocations, contextLocations,regions } from "../Store/LocationStores";


// event handlers
const onSearch = e => {
	if ( e.detail.query === '' ) {
		searchState.setReady()
	} else {
		searchState.setSearching()
	}
}

const onSearchCancel = () => {
	searchState.setReady()
}

const onHideOverlay = () => {
	overlay.hide()
}


// lifecyle
onMount( () => {
	//console.log( 'mount' )
} )

onDestroy( () => {
	overlay.hide()
	searchState.setReady()
} )


// reactive
$: title = $overlay.context && $overlay.context.page_title || ''
$: eyebrow = $overlay.context && $overlay.context.page_eyebrow || ''

</script>

<div class="cul-overlay__outer" data-context="{$overlay.context.id}">

	<div class="cul-overlay__bg" on:click={onHideOverlay} transition:fade></div>

	<div class="cul-overlay__inner" transition:fly={{ x: -100}}>

		{#if ! $allLocations.length}
			<Spinner/>
		{:else}
			<div class="cul-overlay__header">
				<div class="cul-overlay__eyebrow">{eyebrow}</div>

				<div class="cul-overlay__title">{title}</div>

				<button type="button" on:click={onHideOverlay}>
					<svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M4.40234 6.69927L6.28984 4.81177L27.5973 26.1193L25.7098 28.0068L4.40234 6.69927Z" fill="#fff"/>
						<path d="M4.40234 26.1193L25.7098 4.81177L27.5973 6.69927L6.28984 28.0068L4.40234 26.1193Z" fill="#fff"/>
					</svg>
				</button>
			</div>


			<div class="cul-overlay__content">

				<Search
					locations={$contextLocations}
					on:search-query={onSearch}
					on:search-cancel={onSearchCancel}
				/>

				{#if $searchState === 's-ready'}
					<LocationList
						regions={$regions}
						locations={$contextLocations}
					/>
				{/if}
			</div>

			<div class="cul-overlay__footer">
			</div>

		{/if}
	</div>
</div>
